import React from "react"
import Services from "./services/Services"
import Hero from "./hero/Hero"
import Contact from "./contact/contact"
import About from "./about/about"


const Home = () => {
  return (
    <>
      <Hero />
      <Services />
      <About/>
      <Contact/>
   
    
    </>
  )
}

export default Home
